import { Component, Input, OnInit } from '@angular/core';
import { CustomerFilterModel, CustomerModel, CustomerServiceProxy, CustomerStatusModel, CustomerStatusServiceProxy, SortOrder } from '../../../../../shared/service-proxies/event-service-proxy';
import { DestroyService } from '../../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { AuthService } from '../../../../services/auth/auth.service';
import { DateFormatterPipe } from '../../../../pipes/date/date-formatter.pipe';
import { ToastrService } from '../../../../services/toastr/toastr.service';
import { ErrorService } from '../../../../services/error/error.service';

@Component({
    selector: 'app-leads-card',
    templateUrl: './leads-card.component.html',
    styleUrl: './leads-card.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class LeadsCardComponent implements OnInit {
  private customersFilter: CustomerFilterModel = new CustomerFilterModel();
  customers: CustomerModel[] = [];

  statuses: CustomerStatusModel[] = [];

  perPage: number = 4;

  isLoading: boolean = true;
  dataMissing: boolean|string = false || '';

  constructor(private errorService: ErrorService, private _customersService: CustomerServiceProxy, private _customerStatuses: CustomerStatusServiceProxy, private authService: AuthService, private destroyService: DestroyService, private dateFormatterPipe: DateFormatterPipe) {}

  ngOnInit(): void {
    this.getCustomersStatuses();
  }

  getCustomers() {
    this.customersFilter.statuses = [this.statuses.find(status => status.name === 'Новый')?.id || null];
    this.customersFilter.perPage = this.perPage;
    this.customersFilter.sortBy = 'createdAt';
    this.customersFilter.sortOrder = SortOrder.Desc;
    this._customersService.getByFilter(this.customersFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(customers => {
        this.customers = customers.items;
        console.log(this.customers);
        this.isLoading = false;
        this.dataMissing = this.customers.length == 0;
      }, error => {
        console.error(error);
        this.isLoading = false;
        this.dataMissing = 'Не удалось получить список лидов. Попробуйте позже.';
      });
  }

  getCustomersStatuses() {
    this._customerStatuses.getAll(this.authService.getCompanyId())
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(statuses => {
        this.isLoading = false;
        this.statuses = statuses;
        this.getCustomers();
        this.dataMissing = this.statuses.length == 0;
      }, error => {
        console.error(error);
        this.isLoading = false;
        this.dataMissing = 'Не удалось получить список лидов. Попробуйте позже.';
        this.errorService.handleError(error, 'Не удалось получить список лидов. Попробуйте позже.');
    })
  }
  
}
